import StudentCourseDetailsBlock from './StudentCourseDetailsBlock';
import { StudentCourseDetailsBlockProps, StudentCourseDetailsBlockValueProps } from './types';

export type { StudentCourseDetailsBlockProps, StudentCourseDetailsBlockValueProps };
export default StudentCourseDetailsBlock;
